import React, { useContext } from 'react'
import { Col, Row, Input, Select, Button, DatePicker, Radio } from 'antd'
import moment from 'moment'
import { Context, useStore } from '../../../context'

const { Option } = Select
const { Search } = Input

function InventoryTabsHeader(props) {
  const [state] = useContext(Context)
  const { hasPermissions } = useStore(state)

  return (
    <Row gutter={16}>
      <Col xs={7} sm={7} md={7} lg={7}>
        <Select
          value={props.selectedOption}
          className={'single-select'}
          placeholder={'Selecciona una tienda'}
          size={'large'}
          style={{ width: '100%' }}
          onChange={option => {
            props.setSelectedOption(option)
          }}
        >
          {props.shopsList.map(option => (
            <Option key={option.id} value={option.id}>
              {option.name}
            </Option>
          ))}
        </Select>
      </Col>
      <Col xs={11} sm={11} md={11} lg={11}>
        {!!props.selectedOption &&
          (!props.keyTab || props.keyTab === '1' || props.keyTab === '2' ? (
            <Search
              placeholder={props.keyTab === '2' ? 'Buscar por número de factura' : 'Buscar por nombre de producto'}
              className={'tendero-table-search custom-search'}
              size={'large'}
              onSearch={props.onSearch}
            />
          ) : (
            <DatePicker
              placeHolder="Buscar por fecha"
              size={'large'}
              format={'YYYY-MM-DD'}
              className={'date-picker-custom'}
              disabledDate={current => current && current > moment().endOf('day')}
              onChange={(date, dateString) => props.onSearch(dateString)}
            />
          ))}
      </Col>
      <Col xs={6} sm={6} md={6} lg={6} className="text-right">
        {props.selectedOption !== null && props.buttonLabel && props.buttonHandler && hasPermissions([props.createPermissions]) && (
          <Button className={'title-tendero new-button'} onClick={props.buttonHandler}>
            {props.buttonLabel}
          </Button>
        )}
        {props.selectedOption !== null && (!props.keyTab || props.keyTab === '1') &&
        (<>
          <span style={{marginRight:'1rem'}}>Stock Bajo</span>
          <Radio.Group
            className={'radio-group'}
            optionType="button"
            buttonStyle="solid"
            size={'large'}
            value={props.lowStock}
            onChange={value => props.setLowStock(value.target.value)}
          >
            <Radio.Button value={false}>No</Radio.Button>
            <Radio.Button value={true}>Sí</Radio.Button>
          </Radio.Group>
        </>
        )}
      </Col>
    </Row>
  )
}

export default InventoryTabsHeader

InventoryTabsHeader.defaultProps = {
  selectedOption: null,
  buttonLabel: null,
  shopsList: [],
}
